import { render, staticRenderFns } from "./createResource.vue?vue&type=template&id=616d7c37&scoped=true&"
import script from "./createResource.vue?vue&type=script&lang=js&"
export * from "./createResource.vue?vue&type=script&lang=js&"
import style0 from "./createResource.vue?vue&type=style&index=0&id=616d7c37&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616d7c37",
  null
  
)

export default component.exports